import React, { useEffect } from 'react';
export const InsightsPage = () => {
  useEffect(() => {
    document.title = 'Insights | Race Capital';
  }, []);
  const articles = [{
    title: 'First AE: Where Repeatability Begins',
    description: 'Insights on hiring your first Account Executive and building a repeatable sales process.',
    author: 'Matt McLaughlin',
    date: 'November 2025',
    link: 'https://www.linkedin.com/pulse/first-ae-where-repeatability-begins-matt-mclaughlin-thsrc/?trackingId=mn811cJDBe1quaKiZWW94g%3D%3D',
    category: 'Sales'
  }, {
    title: "Your First CRM Isn't About Today's Deals",
    description: 'Understanding the strategic importance of implementing your first CRM system for long-term growth.',
    author: 'Matt McLaughlin',
    date: 'October 2025',
    link: 'https://www.linkedin.com/posts/mwmgtm_your-first-crm-isnt-about-todays-deals-activity-7377022029180489729-Pvb1?utm_source=share&utm_medium=member_desktop&rcm=ACoAACoc0-gBWBDkXmVslxBwjRv2tz9J-W5Ey_M',
    category: 'Sales'
  }, {
    title: 'The Goldilocks Rule for Your First Customers',
    description: 'Read our latest insights on finding your first customers and building repeatable sales motions.',
    author: 'Matt McLaughlin',
    date: 'September 2025',
    link: 'https://www.linkedin.com/pulse/goldilocks-rule-your-first-customers-matt-mclaughlin-95xec/',
    category: 'Go-To-Market'
  }];
  return <div className="w-full bg-white mt-20" data-id="element-391" data-mp="17ucqem7klk1u">
      {/* Hero Section */}
      <section className="w-full pt-20 pb-20 px-6 md:px-12 bg-gradient-to-b from-white to-gray-50/50" data-id="element-392" data-mp="17wfgt7cmxf73">
        <div className="max-w-7xl mx-auto" data-id="element-393" data-mp="t3ca5v0l0lv5">
          <div className="relative mb-6 overflow-visible" data-id="element-394" data-mp="y3rn4lgybrcl">
            <style jsx data-id="element-395" data-mp="y26skvun08eq">{`
              @keyframes fillFromLeft {
                from {
                  transform: scaleX(0);
                  transform-origin: left;
                }
                to {
                  transform: scaleX(1);
                  transform-origin: left;
                }
              }
              .racing-stripe {
                transform: scaleX(0);
                transform-origin: left;
                animation: fillFromLeft 0.8s ease-out forwards;
              }
              .racing-stripe:nth-child(1) {
                animation-delay: 0.1s;
              }
              .racing-stripe:nth-child(2) {
                animation-delay: 0.2s;
              }
              .racing-stripe:nth-child(3) {
                animation-delay: 0.3s;
              }
              .racing-stripe:nth-child(4) {
                animation-delay: 0.4s;
              }
            `}</style>
            <div className="absolute right-[12px] top-0 hidden md:flex flex-col space-y-2 pointer-events-none" data-id="element-396" data-mp="12tkhmrkik0j6">
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/30 to-red-600/10" style={{
              width: '240px',
              marginLeft: '0px'
            }} data-id="element-397" data-mp="yqfi8xvqceyr"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/35 to-red-600/15" style={{
              width: '200px',
              marginLeft: '40px'
            }} data-id="element-398" data-mp="35i2b3pd00i18"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/40 to-red-600/20" style={{
              width: '160px',
              marginLeft: '80px'
            }} data-id="element-399" data-mp="3jefvb68x2xje"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/45 to-red-600/25" style={{
              width: '120px',
              marginLeft: '120px'
            }} data-id="element-400" data-mp="2qogy2nkkju3n"></div>
            </div>
            <h1 className="relative z-10 text-[clamp(2.5rem,5vw,4rem)] font-semibold text-[#070707] tracking-tight leading-[1.15]" data-id="element-401" data-mp="230pmjm6url3f">
              Insights
            </h1>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl leading-relaxed font-light" data-id="element-402" data-mp="eieibq3r6llp">
            Perspectives on go-to-market strategy, enterprise sales, and
            building repeatable revenue from the Race Capital team.
          </p>
        </div>
      </section>
      {/* Articles Grid */}
      <section className="w-full py-20 px-6 md:px-12 bg-white" data-id="element-403" data-mp="iieuf43dqkpl">
        <div className="max-w-7xl mx-auto" data-id="element-404" data-mp="x7ul6k2wuq5a">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-405" data-mp="x6jg8gxqbccl">
            {articles.map((article, index) => <a key={index} href={article.link} target="_blank" rel="noopener noreferrer" className="group bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl hover:shadow-red-600/10 transition-all hover:-translate-y-1" data-id="element-406" data-mp="sbdrzbgutllc" data-mpi={index}>
                <div className="p-8" data-id="element-407" data-mp="33zlvejf3htvo">
                  <div className="flex items-center justify-between mb-4" data-id="element-408" data-mp="340n78q3xqkeg">
                    <span className="text-xs font-semibold text-red-600 bg-red-50 px-3 py-1 rounded-full" data-id="element-409" data-mp="2tvwzu4prio2u">
                      {article.category}
                    </span>
                    <svg className="w-5 h-5 text-gray-400 group-hover:text-red-600 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-410" data-mp="2k5lxgmlq8my2">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-411" data-mp="2f5prwixdsnge" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-[#070707] mb-3 group-hover:text-red-600 transition-colors" data-id="element-412" data-mp="2675i679sto4b">
                    {article.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-6 leading-relaxed" data-id="element-413" data-mp="4d66hksrl4r3">
                    {article.description}
                  </p>
                  <div className="flex items-center text-sm text-gray-500" data-id="element-414" data-mp="3u2trv7fzb3bw">
                    <span className="font-medium" data-id="element-415" data-mp="3u4wssmio6gve">{article.author}</span>
                    <span className="mx-2" data-id="element-416" data-mp="3p4ikd3d5p4wu">•</span>
                    <span data-id="element-417" data-mp="3k4w40l2178jt">{article.date}</span>
                  </div>
                </div>
              </a>)}
          </div>
        </div>
      </section>
    </div>;
};